import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * VerifiedBadge, the 20px accent trust check.
 *
 * CSS selector: `mobile/atoms.css` `.ds-verified`.
 *
 * Doctrine: accent is rationed to state, selection, progress and brand trust.
 * This badge is the brand-trust case, so the accent fill here is correct rather
 * than an exception. The check glyph is drawn on the on-accent dark colour, so
 * it stays legible in both themes without a theme rule.
 *
 * Pass `label={null}` when the badge sits next to visible "Verified" text, so
 * the name is not announced twice.
 */
export const VerifiedBadge = React.forwardRef(function VerifiedBadge(
  { className, label = 'Verified', ...rest },
  ref,
) {
  return (
    <span
      ref={ref}
      role={label ? 'img' : undefined}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : true}
      className={cn('ds-verified', className)}
      {...rest}
    >
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M5 13l4 4L19 7"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
});

export default VerifiedBadge;
